module.exports = __webpack_public_path__ + "static/media/ye.02c6c0d0.svg";